import { configQuery, getFeatureEnabled, FeatureEnabledV2, Throttle, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { RESET_FORM, Feature, COREX_AML_FILES_QUERY } from '@gig/magic-messages';
import '@gig/magic-sdk/dist/adapter/users/getAmlStatus';
import { getUploadFormConfig } from './form-config/upload-form.config.js';
import { initScanVerificationPolling, launchScanVerification } from '../../utils/scan-verification.js';

var VerificationUploadScanFormComponent = /** @class */ (function (_super) {
    __extends(VerificationUploadScanFormComponent, _super);
    function VerificationUploadScanFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.isScanButtonDisabled = false;
        _this.formConfig = [];
        _this.files = [];
        _this.showFilesNotification = false;
        _this.documentSectionsList = [];
        _this.disableManualUpload = false;
        _this.allowAllDocumentsUpload = false;
        _this.hasRequestedDocs = false;
        _this.hasRequestedDocsByCategory = {};
        _this.formKey = 0;
        return _this;
    }
    VerificationUploadScanFormComponent.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loadFilesAndInitializeFormConfig();
                        window.eventBus.subscribe(RESET_FORM, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (event) {
                                    this.resetForm();
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        _b = this;
                        return [4 /*yield*/, configQuery('openVerificationInSameTab')];
                    case 1:
                        _b.openVerificationInSameTab =
                            (_a = (_c.sent())) !== null && _a !== void 0 ? _a : false;
                        return [2 /*return*/];
                }
            });
        });
    };
    VerificationUploadScanFormComponent.prototype.mounted = function () {
        window.addEventListener('address-scan-complete', this.handleCloseIframe);
    };
    VerificationUploadScanFormComponent.prototype.destroyed = function () {
        window.removeEventListener('address-scan-complete', this.handleCloseIframe);
    };
    VerificationUploadScanFormComponent.prototype.loadFilesAndInitializeFormConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allFiles, _a, _b, error_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.fetchUserDocuments()];
                    case 1:
                        allFiles = _c.sent();
                        this.files = allFiles;
                        _a = this;
                        return [4 /*yield*/, getFeatureEnabled(Feature.ALLOW_ALL_DOCUMENTS_UPLOAD)];
                    case 2:
                        _a.allowAllDocumentsUpload = _c.sent();
                        allFiles.forEach(function (file) {
                            if (file.verificationStatus === 'Requested') {
                                _this.hasRequestedDocsByCategory[file.category] = true;
                            }
                        });
                        _b = this;
                        return [4 /*yield*/, getUploadFormConfig(this.documentType, this.files, this.allowAllDocumentsUpload)];
                    case 3:
                        _b.formConfig = _c.sent();
                        this.onFormUpdate({}, true);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        console.error('Error loading files and initializing form config:', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VerificationUploadScanFormComponent.prototype.fetchUserDocuments = function () {
        return window.queryBus.query(COREX_AML_FILES_QUERY);
    };
    Object.defineProperty(VerificationUploadScanFormComponent.prototype, "isScanButtonLoading", {
        get: function () {
            return this.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    VerificationUploadScanFormComponent.prototype.onChange = function (event) {
        var form = event.detail[0].form;
        this.onFormUpdate(this.getFormValue(form), this.isFormInvalid(form));
    };
    VerificationUploadScanFormComponent.prototype.onFormUpdate = function (value, disabled) {
        return {
            value: value,
            disabled: disabled,
        };
    };
    VerificationUploadScanFormComponent.prototype.onScanFailed = function () {
        return true;
    };
    VerificationUploadScanFormComponent.prototype.handleCloseIframe = function () {
        return true;
    };
    VerificationUploadScanFormComponent.prototype.isFormInvalid = function (form) {
        var _this = this;
        return Object.values(form).some(function (field) { return _this.isInvalidField(field); });
    };
    VerificationUploadScanFormComponent.prototype.getFormValue = function (form) {
        var date = form['document-expiry'];
        var number = form['document-number'];
        return {
            Side: form['document-side'].value,
            Type: form['document-type'].value,
            DocumentNumber: this.isValidField(number) ? number.value : '',
            ExpiresOn: this.isValidField(date)
                ? new Date(date.value).toISOString()
                : '',
        };
    };
    VerificationUploadScanFormComponent.prototype.isInvalidField = function (field) {
        return !field.hidden && !field.isValid;
    };
    VerificationUploadScanFormComponent.prototype.isValidField = function (field) {
        return !field.hidden && field.isValid;
    };
    VerificationUploadScanFormComponent.prototype.handleScanButtonClick = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var isSafari, newWindow, url, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isScanButtonDisabled) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        this.isLoading = true;
                        isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                        newWindow = null;
                        if (this.documentType !== 'address' &&
                            !this.openVerificationInSameTab &&
                            isSafari) {
                            newWindow = window.open('about:blank', '_blank');
                        }
                        return [4 /*yield*/, launchScanVerification(this.documentType)];
                    case 2:
                        url = _a.sent();
                        this.isLoading = false;
                        this.isScanButtonDisabled = true;
                        if (!url) return [3 /*break*/, 4];
                        return [4 /*yield*/, initScanVerificationPolling(url, this.openVerificationInSameTab, newWindow)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.isScanButtonDisabled = false;
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.isLoading = false;
                        this.onScanFailed();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    VerificationUploadScanFormComponent.prototype.resetForm = function () {
        this.formKey = Date.now();
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], VerificationUploadScanFormComponent.prototype, "documentType", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.DISABLE_MANUAL_UPLOAD }),
        __metadata("design:type", Object)
    ], VerificationUploadScanFormComponent.prototype, "disableManualUpload", void 0);
    __decorate([
        Throttle(500),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], VerificationUploadScanFormComponent.prototype, "onChange", null);
    __decorate([
        Emit('form-update'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Boolean]),
        __metadata("design:returntype", void 0)
    ], VerificationUploadScanFormComponent.prototype, "onFormUpdate", null);
    __decorate([
        Emit('scan-failed'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VerificationUploadScanFormComponent.prototype, "onScanFailed", null);
    __decorate([
        Emit('iframe-complete'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VerificationUploadScanFormComponent.prototype, "handleCloseIframe", null);
    VerificationUploadScanFormComponent = __decorate([
        Component({
            name: 'corex-verification-upload-scan-form',
        })
    ], VerificationUploadScanFormComponent);
    return VerificationUploadScanFormComponent;
}(Mixins(MagicConfigMixin)));

export default VerificationUploadScanFormComponent;
